import { Avatar, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
// import { Switch } from "@/components/ui/switch";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useAuth } from "modules/authentication/hooks/use-auth";
import { UserData } from "modules/authentication/types/user-data";
import { useFetch } from "modules/main/hooks/useFetch";
import { storePreferencesEndPoint } from "modules/main/services/endpoints";
import { FetchDataOptions } from "modules/main/services/fetchData";
import { StoreData } from "modules/main/types/storeData";
import Amount from "utils/amount";
import { getStoreBdData } from "utils/storeDataManager";

interface StorePreferencesProps {
    storeList:StoreData[]
    openState:boolean;
    openControl: (open: boolean) => void;
}

interface StorePreference {
    id: number;
    name: string;
    enabled: boolean;
    minPurchaseAmount: number;
    freeDelivery: number | null;
    deliveryCost: number;
}

export const StorePreferences:React.FC<StorePreferencesProps> = ({ storeList, openState,openControl }) => {
    const {isLogged} = useAuth();   
    const requestOptions:FetchDataOptions = {
    method:"GET",
        headers:{"content-type":"application/json"}
        }
    const userData = JSON.parse(localStorage.getItem("userData")??"{}") as UserData;       
    const location_id = userData.location_id ?? 1;
    const {data,error,loading} = useFetch<StorePreference[]>(storePreferencesEndPoint(isLogged,location_id),requestOptions);

    return (
        <Dialog open={openState} onOpenChange={openControl}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Tiendas que operan en tu sector</DialogTitle>
                    <DialogDescription>
                        Estas tiendas tienes cerca de tu ubicación que cuentan con despacho a domicilio.
                    </DialogDescription>                    
                </DialogHeader>
                <Table>
                    <TableHeader>
                        <TableRow className="text-xs">
                            <TableHead>Tienda</TableHead>
                            {/* <TableHead className="text-center">Activa</TableHead> */}
                            <TableHead className="text-center">Min de compra</TableHead>
                            <TableHead className="text-center">Envío gratis a partir</TableHead>
                            <TableHead className="text-center">Costo de envío</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody className="text-xs">
                        {data?.map((store) => (
                            <TableRow key={store.id}>                                
                                <TableCell className="flex gap-2 items-center min-w-40">
                                    <Avatar className="w-8 h-8">
                                        <AvatarImage src={getStoreBdData(store.id,storeList).logo_url}/>
                                    </Avatar>
                                    {store.name}
                                </TableCell>
                                {/* <TableCell><Switch  checked={store.enabled}/></TableCell> */}
                                <TableCell className="text-right">
                                    <Amount className="ml-0 font-semibold"
                                        amount={store.minPurchaseAmount} 
                                        currency="CLP" 
                                        locale="es-CL" />
                                </TableCell>
                                <TableCell className="text-right">
                                    {
                                        (store.freeDelivery)?(
                                        <Amount className="ml-0 font-semibold"
                                            amount={store.freeDelivery} 
                                            currency="CLP" 
                                            locale="es-CL" />
                                            ):(<span className="text-muted-foreground">No aplica</span>)
                                    }
                                </TableCell>
                                <TableCell className="text-right">
                                    <Amount className="ml-0 font-semibold"
                                        amount={store.deliveryCost} 
                                        currency="CLP" 
                                        locale="es-CL" />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                {/* <Button variant="default" size="sm" className="mt-4">
                    Guardar Cambios
                </Button> */}
                <DialogFooter>
                    <DialogClose asChild>
                        <Button variant="default">Cerrar</Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
